
import { computed, defineComponent, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { MenuComponent } from "@/assets/ts/components";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import { headerMenuIcons } from "@/core/helpers/config";
import { version } from "@/core/helpers/documentation";

export default defineComponent({
  name: "KTMenu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const store = useStore();

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const checkRole = (roles: Array<string>) => {
      let found = false;
      if (roles && currentUser.value.userRoles) {
        for (let index = 0; index < roles.length; index++) {
          const role = roles[index];
          if (currentUser.value?.userRoles?.indexOf(role) !== -1) {
            found = true;
            break;
          }
        }
      } else {
        found = false;
      }
      return found;
    };

    onMounted(() => {
      MenuComponent.reinitialization();
    });

    return {
      hasActiveChildren,
      headerMenuIcons,
      MainMenuConfig,
      translate,
      version,
      checkRole,
    };
  },
});
